import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  marketingMobileCuttoff,
  iphone5Max,
  white, darkGray, imac13inMax, ipadproMax,
} from '@css/constants'

export const FeatureVideoSectionContainer = styled('div')(css``)

export const InnerContent = styled('div')(css`
  position: relative;
`)

export const FeatureVideoWrapper = styled('div')(css`
  position: absolute;
  top: 0;
  width: 100%;
`);

export const Overlay = styled('div')(css`
  text-align: center;
  position: relative;
  padding-bottom: 15px;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-bottom: 24px;
  }
`)

export const ProductSelectTopText = styled('p')(css`
  ${FontNormal(600)};
  font-size: 18px;
  color: white;
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    font-size: 16px;
  }

  @media(max-width: 350px) {
    font-size: 14px;
  }
`)

export const ProductSelectBottomText = styled('p')(css`
  ${FontNormal(600)};
  font-size: 18px;
  font-style: italic;
  color: white;
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    color: black;
  }

  @media(max-width: 350px) {
    ${fontSize(14)};
  }
  
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: 1072px) {
    color: ${darkGray};
  }
`)

export const OverlayTitle = styled('h1')(css`
  ${FontNormal(600)};
  font-size: 48px;
  color: ${white};
  margin: 0 auto;
  padding: 40px 0 50px;
  max-width: 812px;
  text-align: center;
  text-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);

  @media(max-width: ${marketingMobileCuttoff}) {
    font-size: 36px;
    padding-bottom: 86px;
    padding-left: 16px;
    padding-right: 16px;
    text-align: left;
  }

  @media(max-width: ${iphone5Max}) {
    font-size: 32px;
  }
`)
